import { get, post, destroy } from "./_utils";

export const getAllFormExecutables = (formId) => {
  return get(`/forms/${formId}/form_executables.json`);
};

export const getFormExecutable = (formId, executableId) => {
  return get(`/forms/${formId}/form_executables/${executableId}.json`);
};

export const upsertFormExecutable = (formId, data) => {
  return post(`/forms/${formId}/form_executables.json`, data);
};

export const deleteFormExecutable = (formId, executableId) => {
  return destroy(`/forms/${formId}/form_executables/${executableId}.json`);
};

export const executeFormExecutable = (formId, executableId, context) => {
  return post(
    `/forms/${formId}/form_executables/${executableId}/execute.json`,
    context,
  );
};

export const testFormExecutable = (formId, context) => {
  return post(`/forms/${formId}/form_executables/test.json`, context);
};
